import { render, staticRenderFns } from "./LPStepIcon.vue?vue&type=template&id=10d90f29"
import script from "./LPStepIcon.vue?vue&type=script&lang=ts"
export * from "./LPStepIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports